export enum notificationType {
    resellerSave = 'RESELLER_SAVE',
    resellerUpdate = 'RESELLER_UPDATE',
    resellerDelete = 'RESELLER_DELETE',
    businessSave = 'BUSINESS_SAVE', 
    businessUpdate = 'BUSINESS_UPDATE',
    businessDelete = 'BUSINESS_DELETE',
    locationSave = 'LOCATION_SAVE',
    locationUpdate = 'LOCATION_UPDATE',
    locationDelete = 'LOCATION_DELETE',
    userSave = 'USER_SAVE',
    userUpdate = 'USER_UPDATE',
    contactSave = 'CONTACT_SAVE',
    contactUpdate = 'CONTACT_UPDATE',
    contactStatusUpdate = 'CONTACT_STATUS_UPDATE',
    reviewSiteSave = 'REVIEW_SITE_SAVE',
    reviewSiteUpdate = 'REVIEW_SITE_UPDATE',
    campaignSave = 'CAMPAIGN_SAVE',
    campaignUpdate = 'CAMPAIGN_UPDATE',
    contactHistoryChange = 'CONTACT_HISTORY_CHANGE',
    publishCampaign = 'PUBLISH_CAMPAIGN',
    feedbackUpdate = 'FEEDBACK_UPDATE',
    feedbackSave = 'FEEDBACK_SAVE',
    editBusiness = 'EDIT_BUSINESS',
    removeBusiness= 'REMOVE_BUSINESS',
    editResellers = 'EDIT_RESELLERS',
    removeResellers = 'REMOVE_RESELLERS',
    reviewSiteLocationSave = 'REVIEW_SITE_LOCATION_SAVE',
    reviewSiteLocationUpdate = 'REVIEW_SITE_LOCATION_UPDATE',
    reviewsUpdate = "REVIEWS_UPDATE",
}
